import { render } from "./archiveCheck.vue?vue&type=template&id=9ce38b04&scoped=true"
import script from "./archiveCheck.vue?vue&type=script&lang=js"
export * from "./archiveCheck.vue?vue&type=script&lang=js"

import "./archiveCheck.vue?vue&type=style&index=0&id=9ce38b04&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ce38b04"]])

export default __exports__